import { cn } from '@/lib/cn';

/**
 * Brand hero mark — a wrapped gift (painterly paper + ribbon cross + bow) that
 * gently floats above a soft shadow. Decorative; used on the landing + how-it-
 * works heroes. Matches the gift language used elsewhere (locked screen, loader,
 * OG preview). prefers-reduced-motion freezes the float via the global rule.
 */
interface HeroGiftProps {
  className?: string;
  themeHex?: string;
  ribbonHex?: string;
}

export function HeroGift({
  className,
  themeHex = '#FF6B6B',
  ribbonHex = '#FBBF24',
}: HeroGiftProps) {
  return (
    <div className={cn('relative inline-block', className)} aria-hidden="true">
      {/* soft contact shadow — stays put while the gift floats */}
      <div className="absolute inset-x-0 -bottom-1 mx-auto h-3 w-2/3 rounded-[50%] bg-ink/15 blur-md" />
      <svg viewBox="0 0 200 180" className="wrappa-gift-float relative w-full overflow-visible">
        <g filter="url(#painterly)">
          <rect x="48" y="58" width="104" height="104" rx="20" fill={themeHex} />
          {/* subtle top sheen */}
          <rect x="48" y="58" width="104" height="52" rx="20" fill="#ffffff" opacity="0.07" />
          <rect x="89" y="58" width="22" height="104" fill={ribbonHex} />
          <rect x="48" y="99" width="104" height="22" fill={ribbonHex} />
        </g>
        {/* bow */}
        <g>
          <ellipse cx="82" cy="46" rx="17" ry="12" fill={ribbonHex} transform="rotate(-28 82 46)" />
          <ellipse cx="118" cy="46" rx="17" ry="12" fill={ribbonHex} transform="rotate(28 118 46)" />
          <rect x="92" y="40" width="16" height="22" rx="6" fill={ribbonHex} />
        </g>
      </svg>
    </div>
  );
}
